import { Injectable } from '@angular/core';
import { mapHelper } from '@helpers';
import { GeoJsonPostsResponse } from '@mzima-client/sdk';
import * as L from 'leaflet';

@Injectable()
export class MapBoundsService {
  private yearBoundsCache: Map<number, L.LatLngBounds> = new Map();

  /**
   * Calculate and cache bounds for a year's worth of posts
   */
  public calculateAndCacheYearBounds(year: number, yearData: GeoJsonPostsResponse): void {
    const oldGeoJson: any = yearData.results.map((r) => {
      return {
        type: r.geojson?.type,
        features:
          r.geojson?.features.map((f) => {
            f.properties = {
              id: r.id,
            };
            return f;
          }) ?? [],
      };
    });

    const geoPosts = L.geoJSON(oldGeoJson, {
      pointToLayer: mapHelper.pointToLayer,
    });

    if (geoPosts.getLayers().length > 0) {
      const yearBounds = geoPosts.getBounds();
      this.yearBoundsCache.set(year, yearBounds);
    }
  }

  /**
   * Calculate bounds from an array of posts
   */
  public calculateBoundsFromPosts(posts: any[]): L.LatLngBounds | null {
    const oldGeoJson: any = posts.map((r) => {
      return {
        type: r.geojson?.type,
        features:
          r.geojson?.features.map((f: any) => {
            f.properties = {
              id: r.id,
            };
            return f;
          }) ?? [],
      };
    });

    const geoPosts = L.geoJSON(oldGeoJson, {
      pointToLayer: mapHelper.pointToLayer,
    });

    if (geoPosts.getLayers().length > 0) {
      return geoPosts.getBounds();
    }

    return null;
  }

  /**
   * Get cached bounds for a year
   */
  public getYearBounds(year: number): L.LatLngBounds | undefined {
    return this.yearBoundsCache.get(year);
  }

  /**
   * Check if bounds exist for a year
   */
  public hasYearBounds(year: number): boolean {
    return this.yearBoundsCache.has(year);
  }

  /**
   * Remove bounds for a specific year
   */
  public removeYearBounds(year: number): void {
    this.yearBoundsCache.delete(year);
  }

  /**
   * Clear all cached bounds
   */
  public clearCache(): void {
    this.yearBoundsCache.clear();
  }
}
